
export const errorMessageConstants = {
  SendJoinEmail: [
    {
      errorSubmittingJoinForm:
        'Error submitting user form. Please try again or contact Administrator.',
      joinFormSubmitted:
        'Form has been submitted. A representative will get back to you shortly.',
    },
  ],
  common: [
    {
      apiFailMsg: 'Something went wrong. Please try again.',
      joinFormSubmitted:
        'Form has been submitted. A representative will get back to you shortly.',
    },
  ],

  CompanyGenInfo: [
    {
      errorUpdateGenInfo: 'Error updating Company General Information',
      errorSaveGenInfo: 'Error saving Company General Information',
      errorSocialNetwork: 'Error deleting Social Network',
      errorRevenuDelete: 'Error deleting Revenue',
      errorEmployeeDelete: 'Error deleting Employee',
      errorCertificateDelete: 'Error deleting Certificate',
    },
  ],

  CategoryInfo: [
    {
      errorUpdateInfo: 'Error updating Category',
      errorSaveInfo: 'Error saving Category',
    },
  ],
  CategoryGoalsInfo: [
    {
      errorUpdateInfo: 'Error updating Category KPI',
      errorSaveInfo: 'Error saving Category KPI',
      goalExists: 'Category KPI already exists for the year - ',
    },
  ],
  ReportingPeriodsInfo: [
    {
      errorUpdateInfo: 'Error updating Reporting Period',
      errorSaveInfo: 'Error saving Reporting Period',
      reportingPeriodExists: 'Reporting Period already exists',
      deleteReportingPeriod: 'Error deleting Reporting Period',
      deleteReportingRequest: 'Error deleting Report Request',
    },
  ],
  ReportingPrime: [
    {
      userDetials: 'Error while fetching data',
    },
  ],
  UserInvite: [
    {
      updateList: 'Error updating User Invite',
      cancelInviteDeleteError: 'Error cancelling Invite',
      userExisting:
        'Your are already part of SupplierTraX. Please login to continue.',
    },
  ],

  Invitations: [
    {
      DataNotFound: 'Data not found',
      InvitationCancelled: 'User Invitation has been cancelled',
      NoUser: 'No User Invitatation request found',
      PleaseWait: 'Please wait...',
      LinkExpired: 'Link is expired',
      TokenExpired: 'The link is expired. Please contact Administrator.',
      TokenNotValid: 'The token is not valid. Please contact Administrator.',
      UserAlreadyRegistered: 'User is already registered',
      UserInviteSent: 'User Invitation has been sent by email',
      UserInviteCancelled: 'User Invitation has been cancelled',
      CancelConfirm: 'Are you sure you want to cancel this Invitation ',
    },
  ],

  PrimeReports: [
    {
      DataUpdatedSucessfully: 'has been updated.',
      DataVerifiedSucessfully: 'Selected Suppliers Report has been verified.',
      DataUnverifiedSucessfully: 'Selected Suppliers Report has been unverified.',
      MultiDataVerifiedSucessfully:
        'Selected Suppliers Report has been confirmed.',
      ErrorUpdatingData: 'Error updating data',
    },
  ],
  Certificates: [
    {
      error: 'Error updating data',
      approvedSuccess: 'Certificate has been approved.',
      rejectSuccess: 'Certificate has been rejected.',
      errorSaveInfo: 'Error saving data',
      updateStatusSuccessInfo: 'Certificates has been updated.',
      errorValidateInfo: 'Error validating data',
      duplicateCertificate: 'Duplicate Certificate'
    },
  ],
  TieBreakers: [
    {
      saveTieBreakers: 'Error saving data',
      updateTieBreakers: 'Error updating data',
    },
  ],
  T2Analytics: [
    {
      NoDatatoExport: 'There is no data to export',
      AgencyReportExportName: 'Agency Report',
      AggregateReportExportName: 'Aggregate Group Report',
      CategoryReportExportName: 'Category Report',
      DiversityTypeReportExportName: 'Classification Report',
      EthnicityReportExportName: 'Ethnicity Report',
      GoalReportExportName: 'Goal Report',
      KPIReportExportName: 'KPI Report',
      PrimeReportExportName: 'Prime Report',
    },
  ],
  CorporateLicenses:
    [{
      updateLicense: 'Error updating license',
      GetCorporateLicensesForAddingToCompany: 'Error on getting corporate licenses',
      getCorporateLicenseHistory: 'Error on fetching corporate licenses',
      addCorporateLicensesToCompany: 'Error on adding licenses to company',
      getCorporateLicensesByCorporateId: 'Error on getting company licenses',
      getCorporateCompanies: 'Error on getting corporate companies list.',
      searchCompanyByName: 'Error on searching companies'
    }],
};

export const successMessageConstants = {
  TieBreakers: [
    {
      saveTieBreakersDetail: 'Tie Breakers has been saved.',
      updateTieBreakersDetail: 'Tie Breakers has been updated.',
      saveTieBreakersDiversityTypes: 'Classification has been saved.',
      updateTieBreakersDiversityTypes: 'Classification has been updated.',
      saveTieBreakersAgencies: 'Agencies has been saved.',
      updateTieBreakersAgencies: 'Agencies has been updated.',
    },
  ],
};

export const dataConstants = {
  taxVerfication: {
    sliderText: {
      header: 'Welcome to our community',
      subHeader: 'Why register with SupplierTraX?',
      subHeaderContext:
        ' There are lot of benefits in registering your company as a supplier with SupplierTraX.You instantly unlock the possibility of catering to a multitude of businesses at the same time.Be found through our Network Database or take surveys posted by our Corporate Members.',
      howItsWorks: [
        {
          icon: '../../../../assets/images/silder2_1.svg',
          label: ['Register Your', 'Company', 'with', 'SupplierTraX'],
        },
        {
          icon: '../../../../assets/images/silder2_2.svg',
          label: [
            'Complete your',
            'profile and manage',
            'contacts & certifications.',
          ],
        },
        {
          icon: '../../../../assets/images/silder2_3.svg',
          label: ['Manage your', 'suppliers,', 'invitations etc.'],
        },
      ],
    },
    texDetails: {
      header: 'Tax ID Verification',
      notes:
        'Please provide the following details. (All fields are required unless noted)',
      taxDetails: 'Tax Details',
      companyName: 'Company',
      taxId: 'Tax id',
      validate: 'Validate',
      lookUp: 'Lookup',
      request: 'Request',
      next: 'Next',
      cancel: 'Cancel',
      retry: 'Retry',
      yesProceed: 'Yes, Proceed',
      noRetry: 'No, Retry',
    },
  },
  userRequests: {
    title: 'User Requests',
    firstName: 'First Name',
    lastName: 'Last Name',
    companyName: 'Company',
    receivedDate: 'Received',
    eventName: 'Event',
    role: 'Role',
    email: 'Email',
    phoneNumber: 'Phone Number',
    roleErrorMsg: 'Role is required',
    reject: 'Reject',
    accept: 'Accept',
    cancel: 'Cancel',
    save: 'Save',
    search: 'Search',
    notFound: 'Not Found',
    userAcceptMsg: 'User request has been Approved',
    userRejectMsg: 'User request has been Rejected',
    ok: 'OK',
    doYouWish: 'Would you like to add this user ?',
  },
  admin: {
    events: {
      title: 'Events',
      add: 'Add',
      new: 'New',
      name: 'Name',
      eventNameError: 'Event Name is required',
      displayName: 'Display As',
      displayNameError: 'Display as is required',
      state: 'State',
      notFound: 'Not Found',
      stateError: 'State is required',
      city: 'City',
      cityError: 'City name is required',
      start: 'Start',
      startDate: 'Start Date',
      startDateError: 'Start date is required',
      end: 'End',
      endDate: 'End Date',
      endDateError: 'End Date is required',
      acceptReqError: 'Accept Requests date must be after End date',
      description: 'Description',
      descriptionError: ' Content limited to 1000 characters. Remaining',
      optional: '(Optional)',
      generateQrCode: 'Generate QR Code',
      qrCode: 'QR Code',
      cancel: 'Cancel',
      save: 'Save',
      download: 'Download',
      delete: 'Delete',
      acceptReqUntil: 'Accept Requests Until',
    },
    company: {
      diversityCredit: {
        ownershipDiversity: 'Ownership Certification',
        ownershipDiversityError: "Please select Certified if your company's ownership represents Certification else, select Non-Certified",
        diverse: 'Certified',
        nonDiverse: 'Non-Certified',
        diversityDetails: 'Classification Details',
        provideTheDetails: 'Provide all the Classification details that apply',
        add: 'Add',
        new: 'New',
        showAll: 'Show All',
        view: 'View',
        next: 'Next',
        previous: 'Previous',
        fileName: 'File Name :',
        diversityType: 'Classification',
        agency: 'Agency',
        others: 'Others',
        number: 'Number',
        effectiveDate: 'Effective',
        expirationDate: 'Expiration',
        notes: 'Notes',
        notFound: 'Not Found',
        optional: '(Optional)',
        ifOthers: ' If Others',
        cancel: 'Cancel',
        save: 'Save',

      },
      diversityEthinicity: {
        diversityEthinicity: 'Classification & Ethnicity',
        selectTheDiversity: 'Select the Classification of the majority ownership, if none, choose Non-Diverse',
        cancel: 'Cancel',
        save: 'Save',
        diverse: 'Diverse',
        nonDiverse: 'Non-Diverse',
        diversityTypes: 'Classification',
        ethnicity: 'Ethnicity',
        previous: 'Previous',
        next: 'Next'
      },
      generalInfo: {
        companyInfo: 'Company Information',
        pleaseProvide: 'Please provide your company details',
        cancel: 'Cancel',
        save: 'Save',
        legalName: "Legal Name",
        legalNameError: 'Legal Name is required',
        displayNameError: 'Display As is required',
        tradeName: 'Display As',
        optional: '(Optional)',
        leaglIndentifier: 'Legal Identifier'

      }
    },
    agencies: {
      tasks: {
        verificationTaskss: 'Verification Tasks',
        certificatesToVerify: 'Certificates to Verify',
      }
    }

  },
  notFound: 'Not Found',
  superAdmin: {
    diversity: {
      diversity: 'Classifications',
      newDiversityType: 'New Classification',
      title: 'Classification',
      abbreviation: 'Abbreviation',
      agencies: 'Agencies',
      colorCode: 'Color Code',
      nameError: 'Classification is required',
      abbreviationError: 'Abbreviation is required',
      agenciesError: 'Classification Agencies is required',
      cancel: 'Cancel',
      save: 'Save',
      ok: 'Ok',
      delete: 'Delete',
      new: 'New',
      status: 'Status',
      warningText: 'Something went wrong , please try again later',
    },
    certifyingAgenciesDiversity: {
      title: 'Agency details',
      newDiversityType: 'New Agency',
      certifyingAgenciesName: 'Name',
      abbreviation: 'Abbreviation',
      colorCode: 'Color Code',
      nameError: 'Agency Name is required',
      abbreviationError: 'Abbreviation is required',
      cancel: 'Cancel',
      save: 'Save',
      ok: 'Ok',
      delete: 'Delete',
      new: 'New',
      warningText: 'Something went wrong , please try again later',
    },
    naics: {
      naics: 'Naics',
      title: 'Title',
      code: 'Code',
      notes: 'Notes',
      bussinessSector: 'Business sector',
      commodity: 'Commodity',
      status: 'Status',
      titleError: 'NAICS Title is required',
      codeError: 'NAICS Code is required',
      commodityError: 'NAICS Commodity is required',
      cancel: 'Cancel',
      save: 'Save',
      ok: 'Ok',
      delete: 'Delete',
      new: 'New',
      warningText: 'Something went wrong , please try again later',
    },
    ethnicity: {
      ethnicity: 'Ethnicities',
      newEthnicityType: 'New Ethnicity',
      title: 'Ethnicity',
      abbreviation: 'Abbreviation',
      status: 'Status',
      activeInactive: 'Active/Inactive',
      notes: 'Notes',
      titleError: 'Ethnicity is required',
      abbreviationError: 'Ethnicity abbreviation is required',
      cancel: 'Cancel',
      save: 'Save',
      ok: 'Ok',
      delete: 'Delete',
      new: 'New',
      warningText: 'Something went wrong, please try again later',
    },
    agency: {
      agencies: 'Agencies',
      Agency: 'Agency',
      newAgencyType: 'New Agency Type',
      name: 'Agency',
      abbreviation: 'Abbreviation',
      diversityType: 'Classification',
      status: 'Status',
      activeInactive: 'Active/Inactive',
      notes: 'Notes',
      nameError: 'Agency name is required',
      abbreviationError: 'Abbreviation is required',
      diversityTypeError: 'Classification is required',
      cancel: 'Cancel',
      save: 'Save',
      ok: 'Ok',
      delete: 'Delete',
      new: 'New',
      warningText: 'Something went wrong, please try again later',
    },
    continent: {
      continents: 'Continents',
    },
    categorie: {
      categorie: 'Categories',
      CategoryTitle: 'Corporates',
      delete: 'Delete',
      cancel: 'Cancel',
      save: 'Save',
      new: 'New'
    },
    taxType: {
      taxType: 'Tax Types',
      new: 'New',
      newTaxType: 'New Tax Type',
      name: 'Name',
      format: 'Tax Format',
      registration: 'Registration',
      success: 'Success',
      delete: 'Delete',
      taxTypeUpdate: 'Tax type has been updated',
      taxTypeDelete: 'Tax type has been deleted',
      titleError: 'Tax Type Name is required',
      formatError: 'Tax Type Format is required',
      cancel: 'Cancel',
      save: 'Save',
      ok: 'Ok'
    },
    users: {
      users: 'Users',
      inviteUser: 'Invite User',
      exportExcel: 'Export Excel',
      newUser: 'New User',
      name: 'Name',
      success: 'Success',
      delete: 'Delete',
      firstName: 'First Name',
      lastName: 'Last Name',
      company: 'Company',
      email: 'Email',
      phone: 'Phone',
      role: 'Role',
      userStatus: 'User Status',
      isPrimary: 'Is Primary',
      userDetailsUpdate: 'User Details has been Successfully updated',
      userDetailsDelete: 'User Details has been Successfully deleted',
      firstNameError: 'First Name is required',
      lastNameError: 'Last Name is required',
      phoneNumberError: 'Phone Number is required',
      cancel: 'Cancel',
      save: 'Save',
      ok: 'Ok'
    }
  },
  jointForm: {
    welcomeToOurCommunity: 'Welcome to the SupplierTraX Community',
    whyRegisterDiversity: 'Why register with SupplierTraX?',
    benefitsText: 'There are lot of benefits in registering your company as a supplier with SupplierTraX. You instantly unlock the possibility of catering to a multitude of businesses at the same time. Be found through our Network Database or take surveys posted by our Corporate Members.',
    howItWorks: 'How it Works?',
    registerAsA: 'Register Your',
    company: 'Company',
    regCompany3: 'with',
    regCompany4: 'SupplierTraX',
    completeYour: 'Complete the',
    profileAndManage: 'Company',
    contactsAndCertificates: 'profile and add',
    compProfile4: 'user accounts',
    manageYour: 'Manage your',
    suppliers: 'supplier,',
    invitationEtc: 'network and',
    submitReports: 'submit reports',
    mangProfile4: 'submit reports',
    alreadyJoined: 'Already Joined?',
    login: 'Login',
    registerRequest: 'Register Request',
    pleaseProvide: 'Please provide the following details.',
    allFields: ' (All fields are required unless noted)',
    companyInfo: 'Company Information',
    companyName: 'Company',
    companyNameError: 'Company is required',
    notFound: 'Not Found',
    countryRequired: 'Country is Required',
    state: 'State',
    stateRequired: 'State is Required',
    isYourBuss: 'Is your Business Diverse ?',
    yes: 'Yes',
    no: 'No',
    businessSector: 'Business Sector',
    yourInfo: 'Your Information',
    firstName: 'First Name',
    firstNameError: 'First Name is required',
    city: 'City',
    cityNameError: 'City is required',
    lastName: 'Last Name',
    lastNameError: 'Last Name is required',
    emailAddress: ' Email Address',
    emailAddressError: 'Email Address is required',
    validEmailError: 'Please enter a valid email address',
    phoneNum: 'Phone Number',
    phoneNumError: 'Phone Number is required',
    validPhoneNumError: 'Invalid phone number',
    referral: 'Referral',
    howDoYouAbout: 'How did you learn about SupplierTraX?',
    byRegisterYou: 'By registering, you agree to our',
    termsOfUse: 'Terms of Use',
    aggrement: 'agreement.',
    submit: 'Submit',
    thankYou: 'Thank You!',
    yourSignUp: 'Your Sign-up request has been submitted.',
    ourTeamWill: 'Our team will contact you soon',
    ok: 'Ok',
    alreadyRegistered: 'Already Registered?'
  },
  reporting: {
    reportRequest: {
      requestDetails: 'Request Details',
      submitFrom: 'Submit From',
      sendAt: 'Send At'
    }
  },
  dashboard: {
    corporateDashboard: {
      overview: 'Overview',
      activeReportRequest: 'Active Report Request',
      period: 'Period',
      yearToyearComparision: 'Year to Year Comparison',
      social: 'Social',
      IAF: 'IAF',
      diversityCredit: 'Credit Allocated',
      goalSummary: 'Goal Summary',
      type: 'Type',
      target: 'Target',
      acheived: 'Achieved',
      submit: 'Submit',
      noActiveReportRequest: 'No active report request',
      latestReportRequest: 'Latest Report Request',
      request: 'Request',
      supplierPurchase: 'Supplier Purchases',
      corporateSales: 'Corporate Sales',
      noResultFound: 'No Result Found'
    }
  }
};
export const report = {
  reportingPeroid: {
    primeReports: {
      general: 'General',
      diverseSuppliers: 'Target Suppliers',
    },
  },
};
export const admin = {
  users: {
    users: {
      title: 'Users',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      phoneNumber: 'Phone Number',
      role: 'Role',
      status: 'Status',
      myCorporate: 'My Corporates',
      optional: '(Optional)',
      primary: 'Primary',
      firstNameError: ' First Name is required',
      lastNameError: ' Last Name is required',
      emailError: ' Email is required',
      phoneNumberError: 'Invalid phone number',
      notFound: 'Not Found',
      roleError: 'Role is required',
      inActive: 'Inactive',
      cancel: 'Cancel',
      save: 'Save',
      usersUpdated: 'User details have been updated.',
      ok: 'OK',
      allFieldsMandatory: 'All Fields are mandatory',
      primaryUnique: 'Primary should be  one',
    },
    inviteUsers: {
      title: 'User Invitations',
      inviteUsers: 'Invite Users',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      company: 'Company',
      phoneNumber: 'Phone Number',
      firstNameError: ' First Name is required',
      lastNameError: ' Last Name is required',
      emailError: ' Email is required',
      phoneNumberError: 'Invalid phone number',
      invitationSent: 'Invitation already sent for this user',
      role: 'Role',
      roleError: 'Role is required',
      status: 'Status',
      notFound: 'Not Found',
      expiry: 'Valid Until',
      expiryError: 'Expiry is required',
      cancelInvitation: 'Cancel Invitation',
      send: 'Send',
      cancel: 'Cancel',
      optional: '(Optional)',
      bulkImport: 'Bulk Import'
    },
    roles: {
      title: 'Roles',
      cancel: 'Cancel',
      save: 'Save',
      allFieldsNotify: '*All fields required unless noted',
      roleName: 'Role Name',
      optional: '(Optional)',
      roleDesc: 'Roles Description',
      sno: 'S.No',
      roleError: 'Role Name is required',
      roleErrorDuplicate: 'Role Name is a duplicate',
      add: 'Add',
    },
  },
};

export const allSuppliers = {
  emailInformation: {
    cancel: 'Cancel',
    emailError: 'Please enter a valid email',
    cc: 'CC',
    add: 'Add',
    subText: 'Subject is required',
    useTemplate: 'Use Template',
    saveTemplate: 'Save as Template',
    back: 'Back',
    send: 'Send',
    discard: 'Discard',
    templateName: 'Name',
    templateNameError: 'Name is required',
    description: 'Description',
    optional: '(Optional)',
    subject: 'Subject',
    subjectError: 'Subject is required',
    save: 'Save',
  },
};

export const companyInfo = {
  emailTemplates: {
    title: 'Email Templates',
    add: 'Add',
    new: 'New',
    templateName: 'Name',
    templateNameError: 'Name is required',
    description: 'Description',
    optional: '(Optional)',
    subject: 'Subject',
    subjectError: 'Subject is required',
    cancel: 'Cancel',
    save: 'Save',
    content: 'Content',
    delete: 'Delete',
  },
  notificationTemplates: {
    title: 'Notifications',
    add: 'Add',
    new: 'New',
    templateName: 'Name',
    templateNameError: 'Name is required',
    description: 'Description',
    optional: '(Optional)',
    subject: 'Subject',
    subjectError: 'Subject is required',
    cancel: 'Cancel',
    save: 'Save',
    content: 'Content',
    delete: 'Delete',
    update: 'Update',
  },

};

export const shellHeader = {
  quickLinkAdd: {
    name: 'Name',
    nameError: 'Name is required',
    addToFav: ' Add to Favorites',
    update: 'Update',
    reset: 'Reset',
    myFavourites: 'My Favorites'
  },
  notification: {
    dismiss: 'Dismiss'
  }
}

export const legalInfo = {
  privacyPolicy: {
    title: 'Privacy Policy',
    onlinePrivacy: ' Online Privacy Notice',
    onlinePrivacyData:
      'SupplierTraX has adopted this Privacy Notice in order to assure Users of our commitment and dedication to privacy. The following Privacy Notice applies to the Web site “http://portal.suppliertrax.ai” (site). This Privacy Notice does not apply to information collected offline or via online sources other than http://portal.suppliertrax.ai. We invite you to visit the site to search or browse without revealing personal information or registering with SupplierTraX, however, as we gather information about your usage or as you may choose to give SupplierTraX personal information via the site, SupplierTraX will let you know how we will use such information and provide you with an option to opt out. With this notice, your continued use of the site will indicate your agreement to this Privacy Notice.',
    registration: 'Registration',
    registrationData:
      'Registration is not required to gain access to the site. However, there are sections of the site which do require a password to provide you with certain services, specific material and information.',
    useStatistic: 'Usage Statistics',
    useStatisticData:
      'Whether you register or not, when you visit the site, some information such as your Internet Protocol (IP) address, Internet service provider, operating system, the service from which you arrived, the page you requested, the time and date of your visit, and potentially other site usage statistics will be collected automatically as part of the software processes of the Web page. This information itself does not personally identify you, but could potentially be linked with personal information that you provide SupplierTraX. These statistics allow SupplierTraX to analyze the effectiveness of its site, make improvements where needed and potentially to market SupplierTraX products and services to you. Generally, this information is kept as long as required to support the improvements of the site and could be shared with our advisors, agents or other third parties.',
    cookies: 'Cookies',
    cookiesData:
      'A cookie is a string of information that a Web site saves on a visitor’s computer, and that the visitor’s browser provides to the Web site operator each time the visitor returns.',
  },
  termsUse: {
    title: 'Terms of Use',
    termsAccept:
      'The following terms and conditions shall be deemed to have been accepted by the user on usage of the website portal.suppliertrax.ai.',
    youAreRequested:
      'You are requested to read them carefully before you use the services of this site.',
    termsList: {
      listValues: [
        {
          text: 'The term User shall refer to the user who is browsing the site. The term site refers to supliertrax.com owned and monitored by SupplierTraX.',
        },
        {
          text: 'By using the site, the User agrees to follow and be bound by the following terms and conditions and these terms and conditions may be revised or modified at any time by SupplierTraX without any notice to the User.',
        },
        {
          text: 'SupplierTraX may terminate User’s access to site at any time for any reason. The provisions regarding to disclaimer of warranty, accuracy of information and indemnification shall survive such termination. SupplierTraX may monitor access to the site.',
        },
        {
          text: 'The software, text, images, graphics, video, and audio used and/or appearing on this site belong to SupplierTraX, its parent, affiliates and associates and are protected by applicable laws.All the rights including, copyrights and intellectual property rights, in the material presented on the site which belongs to third parties(“Third Parties”), shall be governed by the terms and conditions as specified by such Third Parties in this behalf.User is advised and User agreed to peruse and abide by, such terms and conditions as specified by the Third Parties.No material from the site shall be copied, modified, reproduced, republished, uploaded, transmitted, posted, or distributed in any form without prior written permission from SupplierTraX. All rights not expressly granted herein are reserved.Unauthorized use of the materials appearing on the site may violate copyright, trademark and other applicable laws, and could result in criminal or civil penalties.',
        },
        {
          text: 'SupplierTraX does not make any warranties, express or implied, including, without limitation, those of merchantability and fitness for a particular purpose, with respect to any information, data, statements or products made available on the site.',
        },
        {
          text: 'The site, and all content, materials, information, software, products and services provided on the site, are provided on an “as is” and “as available” basis. SupplierTraX expressly disclaims all warranties of any kind, whether express or implied, including, but not limited to, the implied warranties of merchantability, fitness for a particular purpose and non-infringement.',
        },
        {
          text: 'SupplierTraX shall have no responsibility for any damage to User’s computer system and/ or loss of data that result from the download of any content, materials, and information from the site.',
        },
        {
          text: 'SupplierTraX may change or discontinue any aspect of the site at any time, including, its content and/ or features. SupplierTraX reserves the right to change the terms and conditions applicable to use of the site.Such changes shall be effective immediately upon notice, which shall be placed on the site.',
        },
        {
          text: 'In no event shall SupplierTraX be liable for damages of any kind, including without limitation, direct, incidental and/or consequential damages (including, but not limited to, damages for lost profits, business interruption and loss of programs or information) arising out of the use of or inability to use site, or any information provided on the site, or for any other reasons whatsoever.',
        },
        {
          text: 'User agrees to indemnify, defend and hold SupplierTraX harmless from and against any and all losses, expenses, damages and costs, including reasonable attorneys’ fees, arising out of or relating to any misuse by the User of the content and services provided on the site.',
        },
        {
          text: 'The information contained in the site has been obtained from sources believed to be reliable. SupplierTraX disclaims all warranties as to the accuracy, completeness or adequacy of such information.',
        },
        {
          text: 'SupplierTraX makes no warranty that: (a) The site will meet User’s requirements; (b) The site will be available on an uninterrupted, timely, secure, or error- free basis (c) The results that may be obtained from the use of the site or any services offered through the site will be accurate or reliable.',
        },
        {
          text: 'The User’s right to privacy is of paramount importance to SupplierTraX. Any information provided by the User will not be shared with any third party. SupplierTraX reserves the right to use the information to provide the User a more personalized online experience.',
        },
        {
          text: 'The site may provide links to third party’s web sites and access to content, products and services from third parties, including users, advertisers, affiliates and sponsors of the site. The User agrees that SupplierTraX is not responsible for the availability of, and content provided on, third party web sites. The User is requested to peruse the policies posted by other web sites regarding privacy and other topics before use. SupplierTraX is not responsible for third party content accessible through the site, including opinions, advice, statements and advertisements, and User shall bear all risks associated with the use of such content. SupplierTraX is not responsible for any loss or damage of any sort User may incur from dealing with any third party.',
        },
      ],
    },
  },
};
